import api from "../../api";
export default {
    namespaced: true,
    state: {
        total_unread: 0,
        total_read: 0,
        items: []
    },
    mutations: {
        LOAD_NOTIFICATIONS(state, notifications) {
            state.items = notifications.data;
            state.total_read = notifications.total_read_notifications;
            state.total_unread = notifications.total_unread_notifications;
        },

        MARK_AS_READ(state, id) {
            let index = state.items.filter(notication => notication.id == id)
            state.items.splice(index, 1)

            if (state.total_unread)
                state.total_unread = state.total_unread - 1;

                this.dispatch('notification/loadNotifications');

        },

        MARK_ALL_AS_READ(state) {
            state.items = []
        },

        ADD_NOTIFICATION(state, notication) {
            state.items.unshift(notication)
        },
    },


    actions: {
        loadNotifications(context, type = 'unread') {
            api.get('notifications', {
                params: { type: type }
            })
                .then(response => {
                    context.commit('LOAD_NOTIFICATIONS', response.data)
                })
        },

        markAsRead(context, params) {
            api.put('notification-read', params)
                .then(() => context.commit('MARK_AS_READ', params.id))
        },

        markAllAsRead(context) {
            api.put('notification-all-as-read')
                .then(() => context.commit('MARK_ALL_AS_READ'))
        }
    }
}
